<h2 mat-dialog-title *ngIf="editCarrier.id === undefined">
  <i class="fas fa-plus me-2"></i>Create Carrier
</h2>
<h2 mat-dialog-title *ngIf="editCarrier.id !== undefined">
  <i class="fas fa-pen me-2"></i>Edit Carrier for
  {{ editCarrier.name }}
</h2>
<mat-dialog-content class="mat-typography">
  <form #CarrierForm="ngForm" id="CarrierForm" name="CarrierForm">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <input
              type="text"
              matInput
              id="name"
              name="name"
              [(ngModel)]="editCarrier.name"
              placeholder="Name"
              required
              #name="ngModel"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <input
              type="text"
              matInput
              id="description"
              name="description"
              [(ngModel)]="editCarrier.description"
              placeholder="Description"
              required
              #description="ngModel"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <input
              type="text"
              matInput
              id="email"
              name="email"
              [(ngModel)]="editCarrier.email"
              placeholder="Email"
              #email="ngModel"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <input
              type="text"
              matInput
              id="phone"
              name="phone"
              [(ngModel)]="editCarrier.phoneNumber"
              placeholder="Phone #"
              mask="(000) 000-0000"
              #phone="ngModel"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="custom-dialog-actions">
    <div class="btn-group">
      <button
        *ngIf="!submitting"
        type="submit"
        form="CarrierForm"
        [disabled]="CarrierForm.invalid"
        class="custom-button save-button"
        (click)="saveCarrierClicked()"
      >
        <span class="fa-icon-wrapper"><i class="fas fa-save"></i></span>
        Save
      </button>
      <mat-spinner *ngIf="submitting" [diameter]="20"></mat-spinner>
      <button
        class="custom-button cancel-button"
        (click)="cancelClicked(CarrierForm, false)"
      >
        <span class="fa-icon-wrapper"><i class="fas fa-times"></i></span>
        Cancel
      </button>
    </div>
    <div class="spinner-wrapper d-none">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</mat-dialog-actions>
